module.exports = __webpack_public_path__ + "img/6.465319f4.jpg";